import { combineReducers } from 'redux-immutable';
import plan from './PlanReducer';
import price from './PriceReducer';
import products_sale from './ProductsSaleReducer';
import total_sale from './TotalSaleReducer';
import product_ingredients from './ProductIngredientReducer';
import modal_product_ingredients from './ModalProductIngredientsReducer';
import modal_recipes_products_pre_make_reducer from './ModalRecipesProductsPreMakeReducer';
import payment_dialog from './PaymentDialogReducer';
import alert from './AlertReducer';
import products_stock from './ProductStockReducer';
import product_stock_modal from './ModalProductStockReducer';
import product_stock_update_modal from './ModalProductStockUpdateReducer';
import ingredient_stock_modal from './ModalIngredientStockReducer';
import ingredients_stock from './IngredientStockReducer';
import ingredient_stock_update_modal from './ModalIngredientStockUpdateReducer';
import expense_dialog from './ModalExpenseDialogReducer';
import expense_detail from './ExpenseDetailReducer';
import toast from './ToastReducer';
import printer_settings_modal from './PrinterSettingsModalReducer';
import send_invoice_by_email from './SendInvoiceByEmailReducer';
import cancel_sale from './AlertCancelSaleReducer';
import sale_canceled from './SaleCanceledReducer';
import dynamic_table_data from './DynamicTableDataReducer';
import find_client from './FindClientReducer';
import select_client from './ClientSelectReducer';
import client_dialog from './ClientDialogReducer';
import provider_dialog from './ProviderDialogReducer';
import provider_select from './ProviderSelectReducer';
import expense_select from './ExpenseSelectReducer';
import section_dialog from './SectionDialogReducer';
import section_select from './SectionSelectReducer';
import ingredient_dialog from './IngredientDialogReducer';
import ingredient_select from './IngredientSelectReducer';
import tax_dialog from './TaxDialogReducer';
import tax_select from './TaxSelectReducer';
import recipe_dialog from './RecipeDialogReducer';
import recipe_select from './RecipeSelectReducer';
import product_dialog from './ProductDialogReducer';
import product_select from './ProductSelectReducer';
import category_dialog from './CategoryDialogReducer';
import category_select from './CategorySelectReducer';
import combo_dialog from './ComboDialogReducer';
import waiter_dialog from './WaiterDialogReducer';
import waiter_select from './WaiterSelectReducer';
import simple_table_data from './SimpleTableDataReducer';
import partial_open_box_dialog from './PartialOpenBoxDialogReducer';
import select_partial_open_box from './PartialOpenBoxSelectReducer';
import combo from './ComboReducer';
import payments_dialog from './PaymentsDialogReducer';
import ticket_dialog from './TicketDialogReducer';
import ticket_select from './TicketSelectReducer';
import ticket_client_dialog from './TicketClientDialogReducer';
import ticket_check_dialog from './TicketCheckReducer';
import ticket_edit_dialog from './TicketEditDialogReducer';
import ticket_history_dialog from './TicketHistoryReducer';
import open_table from './OpenTableReducer';
import update_table from './UpdateTableReducer';
import modal_other_sales from './ModalOtherSalesDialogReducer';
import other_sale_select from './OtherSaleSelectReducer';
import question_dialog from './QuestionDialogReducer';
import product_recipes_dialog from './ProductRecipesDialogReducer';
import recipes_stock from './RecipeStockReducer'
import product_variants_dialog from './ProductVariantsDialogReducer';
import product_prices_dialog from './ProductPricesDialogReducer';

const RootReducer = combineReducers({
    plan,
    price,
    products_sale,
    total_sale,
    payment_dialog,
    alert,
    product_ingredients,
    modal_product_ingredients,
    products_stock,
    product_stock_modal,
    product_stock_update_modal,
    ingredient_stock_modal,
    ingredients_stock,
    ingredient_stock_update_modal,
    expense_dialog,
    expense_detail,
    toast,
    printer_settings_modal,
    send_invoice_by_email,
    cancel_sale,
    sale_canceled,
    dynamic_table_data,
    find_client,
    select_client,
    client_dialog,
    provider_dialog,
    provider_select,
    expense_select,
    section_dialog,
    section_select,
    ingredient_dialog,
    ingredient_select,
    tax_dialog,
    tax_select,
    product_dialog,
    product_select,
    category_dialog,
    category_select,
    combo_dialog,
    waiter_dialog,
    waiter_select,
    simple_table_data,
    partial_open_box_dialog,
    select_partial_open_box,
    combo,
    payments_dialog,
    ticket_dialog,
    ticket_select,
    ticket_client_dialog,
    ticket_check_dialog,
    ticket_edit_dialog,
    ticket_history_dialog,
    open_table,
    update_table,
    modal_other_sales,
    other_sale_select,
    question_dialog,
    recipe_dialog,
    recipe_select,
    product_recipes_dialog,
    modal_recipes_products_pre_make_reducer,
    recipes_stock,
    product_variants_dialog,
    product_prices_dialog
});

export default RootReducer;


// WEBPACK FOOTER //
// ./src/reducers/RootReducer.js